/**
 * Syncs all cookies to cart attributes for SGTM
 */
(function() {
  if (!document.cookie) return;

  const cookies = document.cookie;
  const maxLength = 250;
  const attributes = {};

  for (let i = 0; i * maxLength < cookies.length; i++) {
    const chunk = cookies.substring(i * maxLength, (i + 1) * maxLength);
    attributes[`_cookies_${i + 1}`] = chunk;
  }

  fetch(theme.routes.cartUpdate, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes })
  });

  console.info('✓ Cart attributes synced:', Object.keys(attributes).length, 'chunks');
})();
